(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doctor-hero"] && !Shopify.designMode) return;
  try {
    
  /* (Your existing JS-only scripts, if any, go here) */

  } catch(e) { console.error(e); }
})();
})();
